<template>
  <transition name="fade">
    <div class="lp-toast-bg" v-show="vToast">
      <div class="lp-toast">
        <div>{{ msg }}</div>
        <div>{{ percent }}%</div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'LpProgressToast',
    created() {
      this.$root.$on('showProgressToast', res => {
        this.vToast = true;
        this.msg = res.msg;
        this.percent = res.percent
      });
      this.$root.$on('closeProgressToast', res => {
        this.vToast = false;
        this.msg = '';
        this.percent = 0;
      })
    },
    data() {
      return {
        vToast: false,
        msg: '',
        percent: 0
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-toast-bg
    position fixed
    z-index 9002
    top 0
    left 0
    right 0
    bottom 0
    width 100%
    height 100%
    display flex

  .lp-toast
    width 60%
    max-width 380px
    margin auto
    padding 12px
    font-size 0.9rem
    color white
    background-color rgba(0,0,0,0.65)
    text-align center
    border-radius 4px

  .fade-enter-active
  .fade-leave-active
    transition opacity .3s
  .fade-enter
  .fade-leave-to
    opacity 0

</style>
